import { api } from './client';

export interface AdminUser {
  id: string;
  cognitoUserId: string;
  name: string;
  email: string;
  plan: 'FREE' | 'PREMIUM' | 'COURTESY' | 'LIFE_PARTNER';
  planUntil: string | null;
  createdAt: string;
}

export const adminApi = {
  listUsers: () => api.get<AdminUser[]>('/admin/users'),
  grantCourtesy: (userId: string, days = 30) =>
    api.post<AdminUser>(`/admin/users/${userId}/courtesy`, { days }),
  grantLifePartner: (userId: string) =>
    api.post<AdminUser>(`/admin/users/${userId}/life-partner`, {}),
};
